import React, { useEffect, useState } from "react";
import appVersion from "../app-version.json";
import {
  exportNativeDiagnosticLogs,
  getNativeAppVersion,
  isNativeMobileShell,
} from "../native/mobileBridge";

const Footer = () => {
  const [displayVersion, setDisplayVersion] = useState(appVersion.name);
  const [showDiagnostics, setShowDiagnostics] = useState(false);
  const [exportStatus, setExportStatus] = useState("");

  useEffect(() => {
    setShowDiagnostics(isNativeMobileShell());
    setDisplayVersion(getNativeAppVersion() || appVersion.name);

    const handleExportResult = ({ detail }) => {
      setExportStatus(
        detail?.status === "success"
          ? `Saved to ${detail.message}`
          : detail?.message || "Unable to export diagnostic logs."
      );
    };

    window.addEventListener("plutonic-log-export", handleExportResult);
    return () =>
      window.removeEventListener("plutonic-log-export", handleExportResult);
  }, []);

  const handleExportLogs = () => {
    setExportStatus("Exporting diagnostic logs…");
    if (!exportNativeDiagnosticLogs()) {
      setExportStatus("Log export is only available in the Android app.");
    }
  };

  return (
    <footer className="relative z-20 bg-[#22AAEE] text-white pt-4 pb-24 lg:pb-4">
      <div className="max-w-screen-lg mx-auto flex flex-col items-center text-center px-4">
        <div className="mb-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-2">
          <span className="text-sm">
            © 2026 Plutonic, Inc. All Rights Reserved.
          </span>
          <span className="hidden sm:inline">|</span>
          <a
            href="/terms"
            className="text-white underline hover:text-gray-200 text-sm"
          >
            Terms and Conditions
          </a>
          <span className="hidden sm:inline">|</span>
          <a
            href="/privacy"
            className="text-white underline hover:text-gray-200 text-sm"
          >
            Privacy Policy
          </a>
          <span className="hidden sm:inline">|</span>
          <a
            href="/account-deletion"
            className="text-white underline hover:text-gray-200 text-sm"
          >
            Delete Account
          </a>
          <span className="hidden sm:inline">|</span>
          <span className="text-sm">Version {displayVersion}</span>
        </div>

        {showDiagnostics && (
          <div className="mb-3 flex flex-col items-center gap-2">
            <button
              type="button"
              onClick={handleExportLogs}
              className="rounded-full border border-white px-4 py-2 text-sm font-semibold text-white transition hover:bg-white hover:text-[#1687bd] focus:outline-none focus:ring-2 focus:ring-white"
            >
              Export Diagnostic Logs
            </button>
            {exportStatus && (
              <p className="max-w-md break-words text-xs text-white">
                {exportStatus}
              </p>
            )}
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
